//日语
export default {
    今日涨跌:"今日の変動",
    商品:"商品",
    交割:"配達",
    关于我们:"私たちについて",
    账变记录:"アカウント変更記録",
    股票:"ストック",
    加密货币:"暗号通貨",
    加载中:"読み込み中...",
    已经全部加载完毕:"すべてロードされました",
    暂无记录:"記録なし",
    高级认证:"高度な認定",
    姓名:"名前",
    请输入姓名:"あなたの名前を入力してください",
    护照编号:"パスポート番号",
    请输入护照编号:"パスポート番号を入力してください",
    护照照片:"パスポートの写真",
    申请认证:"認証を申請する",
    提示:"ヒント",
    确定:"もちろん",
    提交失败:"送信に失敗しました",
    上传失败:"アップロードに失敗しました",
    身份认证:"認証",
    身份证号:"ID番号",
      全球领先的期货和数字资产平台: "グローバルをリードする先物とデジタル資産プラットフォーム",
    请输入身份证号:"識別番号を入力してください",
    身份证照片:"証明写真",
    申请认证:"認証を申請する",
    修改资金密码:"ファンドのパスワードを変更する",
    旧密码:"以前のパスワード",
    请输入旧密码:"古いパスワードを入力してください",
    新密码:"新しいパスワード",
    请输入6位数字:"6桁を入力してください",
    确认新密码:"新しいパスワードを確認します",
    请再次输入新密码:"新しいパスワードをもう一度入力してください",
    提交:"提出する",
    请输入新密码:"新しいパスワードを入力してください",
    请输入6位数新密码:"新しい6桁のパスワードを入力してください",
    请确认两次密码输入一致:"入力した 2 つのパスワードが一致していることを確認してください",
    修改登录密码:"ログインパスワードを変更する",
    密码长度:"パスワード(6～12文字)",
    密码长度提示:"数字または文字を含む 6 ～ 12 文字を入力してください",
    客服:"顧客サービス",
    永续:"持続可能な",
    交割:"配達",
    永续合约:"無期限契約",
    交割合约:"納品契約",
    全仓:"倉庫がいっぱい",
    开多:"長く開く",
    开空:"オープンショート",
    价格:"価格",
    开仓金额:"開口量",
    可用金额:"利用可能量",
    合约金额:"契約額",
    保证金:"マージン",
    手续费:"手数料",
    看涨:"強気な",
    看跌:"弱気",
    交割时间:"納期",
    数量:"量",
    持有仓位:"ポジションを保持する",
    当前委托:"現在の注文",
    历史订单:"歴史的な注文",
    暂无数据:"データなし",
    购买价:"購入金額",
    市价: "市場価格",
    限价: "価格制限",
    现价:"現在の価格",
    金额:"額",
    盈亏:"利益と損失",
    操作:"操作する",
    平仓:"クローズポジション",
    撤单:"注文をキャンセルする",
    方向:"方向",
    剩余时间:"残り時間",
    交割时间:"納期",
    详情:"詳細",
    名称:"名前",
    最新价格:"最新の価格",
    h24涨跌:"24時間の浮き沈み",
    h24涨跌幅:"24時間増減",
    请输入开仓金额:"開始金額を入力してください",
    请输入开仓价格:"始値を入力してください",
    确定执行撤单操作:"注文をキャンセルしてもよろしいですか?",
    确定执行平仓操作:"ポジション決済操作を実行しますか?",
    交割合约历史:"配送契約履歴",
    历史仓位:"歴史的地位",
    到期时间:"有効期限",
    闪兑:"フラッシュ交換",
    从:"から",
    最大:"最大",
    可用数量:"利用可能な数量",
    至:"に",
    复制成功:"正常にコピーされました",
    基金理财:"基金の財務管理",
    托管金额:"エスクロー金額",
    总收益:"総収入",
    当日收益:"その日の収入",
    托管订单:"エスクロー注文",
    规则:"ルール",
    日收益:"一日の収入",
    限额:"限界",
    周期:"サイクル",
    天:"空",
    立即买入:"今すぐ購入",
    购买:"買う",
    购买日:"購入日",
    起息日:"実行日",
    派息时间:"配当金支払時期",
    每日:"毎日",
    计息结束日:"利息発生終了日",
    提前赎回:"早期償還",
    预计收益:"推定収益",
    今日日收益:"今日（一日の収入）",
    最少可投:"最低投資額",
    最大可投:"最大投資額",
    请输入买入金额:"購入金額を入力してください",
    可用金额:"利用可能量",
    请输入买入金额:"購入金額を入力してください",
    质押金额:"誓約額",
    累计收益:"累計収入",
    开始时间:"開始時間",
    结束时间:"終了時間",
    理财规则:"財務ルール",
    理财规则1:"財務管理はUSDをプラットフォームに委託して行われ、プラットフォームの専門チームが金融裁定取引を行い、参加者は資金保管期間中プラットフォームの財務管理収入の一部を得ることができます。",
    收益计算:"収益計算",
    理财规则2:"会員はプラットフォームに10,000Uを入金し、5日サイクルで日当0.3%~0.5%の金融商品を選択します。",
    最低:"最低",
    最高:"最高",
    理财规则3:"両方: 5日後に入手可能",
    理财规则4:"収益は毎日分配され、分配された収益はいつでもアクセスして引き出すことができ、元本に預け入れることができ、満期後は自動的に口座に返金されます。",
    关于违约金:"賠償金の清算について",
    理财规则5:"未期限の元本を移管する場合には、清算損害金が発生します。",
    理财规则6:"賠償額＝和解率×残日数×投資額。",
    理财规则7:"例：本商品の損害賠償精算比率は、",
    剩余:"残り",
    天到期投资:"有効期限は数日で、投資金額は",
    则:"しかし",
    违约金:"損害賠償",
    实际退还本金为:"返される実際のプリンシパルは次のとおりです。",
    现货账户:"スポットアカウント",
    总资产:"総資産",
    充币:"コインを入金する",
    提币:"コインを引き出す",
    闪兑:"フラッシュ交換",
    投资组合:"ポートフォリオ",
    冻结数量:"冷凍量",
    帮助中心:"ヘルプセンター",
    自选:"オプション",
    行情:"引用",
    资金:"資金",
    资讯:"情報",
    我的:"私の",
    交易对:"取引ペア",
    最新价:"最新の価格",
    成交量:"音量",
    标记价格:"マーク価格",
    h24最高价:"24時間最高値",
    h24最低价:"24時間最低価格",
    h24成交量:"24時間の取引量",
    h24交易额:"24時間の取引量",
    分时:"時間を共有する",
    分1:"1点",
    分5:"5点",
    分15:"15点",
    分30:"30点",
    小时1:"1時間",
    天1:"1日",
    周1:"1週間",
    月1:"1月",
    委托订单:"注文",
    最新交易:"最新の取引",
    买入:"買う",
    卖出:"売る",
    时间:"時間",
    方向:"方向",
    取消自选成功:"選択を正常にキャンセルしました",
    添加成功:"正常に追加されました",
    登录:"ログイン",
    账户:"アカウント",
    邮箱:"郵便",
    手机号:"電話番号",
    请输入账户:"アカウントを入力してください",
    请输入邮箱:"メールアドレスを入力してください",
    请输入手机号:"電話番号を入力してください",
    密码:"パスワード",
    请输入密码:"パスワードを入力してください",
    忘记密码:"パスワードを忘れましたか？",
    还没有账号:"まだアカウントがありません",
    去注册:"登録に行く",
    请输入登录账号:"ログインアカウントを入力してください",
    请输入登录密码:"パスワードを入力してください",
    登录失败:"ログインに失敗しました",
    历史记录:"歴史の記録",
    充值:"補充する",
    提现:"撤回する",
    未审核:"未レビュー",
    成功:"成功",
    失败:"失敗",
    快捷入口:"クイックエントリー",
    资金密码:"基金のパスワード",
    登录密码:"ログインパスワード",
    账变记录:"アカウント変更記録",
    邀请推广:"プロモーションを招待する",
    通用:"ユニバーサル",
    语言:"言語",
    在线客服:"オンラインサービス",
    身份认证:"認証",
    高级认证:"高度な認定",
    更多:"もっと",
    帮助中心:"ヘルプセンター",
    关于我们:"私たちについて",
    退出:"やめる",
    已提交身份认证:"あなたはあなたの身元情報を提出しました、そしてそれは審査中です",
    您已完成身份认证:"本人確認が完了しました",
    您已完成高级认证:"上級認定資格を完了しました",
    确定退出登录:"ログアウトしてもよろしいですか?",
    资讯:"情報",
    公告:"発表",
    状态:"州",
    已成交:"交渉成立",
    委托金额:"手数料金額",
    剩余金额:"バランス",
    订单类型:"注文タイプ",
    市价委托:"成行注文",
    限价委托:"指値注文",
    订单号:"注文番号",
    委托时间:"コミッションタイム",
    U本位合约历史:"Uベースの契約履歴",
    成交数量:"取引数",
    实现盈亏:"損益を実現する",
    推广记录:"昇進実績",
    我的总推广:"私の一般的なプロモーション",
    总充值:"合計リチャージ",
    一代人数:"世代数",
    二代人数:"第二世代の数",
    三代人数:"3世代の数",
    立即推广:"今すぐプロモーションする",
    我的推广:"私の昇進",
    用户名:"ユーザー名",
    行情:"引用",
    加密货币:"暗号通貨",
    外汇:"外国為替",
    股票:"ストック",
    现货交易:"現物取引",
    期货:"先物取引",
    热门:"人気のある",
    涨幅榜:"獲得者リスト",
    跌幅榜:"敗者リスト",
    快速充币:"クイック入金",
    保存二维码:"QRコードを保存する",
    复制地址:"アドレスをコピーする",
    转出地址:"転送先アドレス（オプション）",
    请输入转出地址:"転出先住所を入力してください",
    粘贴:"ペースト",
    充币数量:"入金額",
    请输入充币数量:"入金額を入力してください",
    区块链网络:"ブロックチェーンネットワーク",
    付款凭证:"支払い伝票 (支払い詳細のスクリーンショットをアップロード)",
    请输入充值数量:"チャージ金額を入力してください",
    充值通道:"リチャージチャンネル",
    请选择充值币种:"リチャージ通貨を選択してください",
    官方充值通道:"公式リチャージチャンネル",
    设置密码:"パスワードを設定してください",
    确认密码:"パスワードを認証する",
    验证码:"検証コード",
    请输入验证码:"確認コードを入力してください",
    获取验证码:"確認コードを取得する",
    重新发送:"再送信",
    邀请码:"招待コード",
    请输入邀请码:"招待コードを入力してください",
    我已阅读并同意:"読んで同意します",
    服务条款:"利用規約",
    注册:"登録する",
    已有账号:"すでにアカウントをお持ちですか",
    去登录:"ログインに移動",
    请再次输入密码:"パスワードをもう一度入力してください",
    请同意服务条款:"利用規約に同意してください",
    注册失败:"登録に失敗しました",
    欢迎来到:"へようこそ",
    全球最大的区块链资产平台:"世界最大のブロックチェーン資産プラットフォーム",
    分享二维码:"QRコードをシェアする",
    链接分享:"リンク共有",
    复制:"コピー",
    您的邀请码:"あなたの招待コード",
    到数字币地址:"デジタル通貨アドレスへ",
    选择币种:"通貨を選択してください",
    区块链网络:"ブロックチェーンネットワーク",
    提币说明:"出金指示",
    提现费用:"出金手数料",
    可到账数量:"在庫数",
    可用:"利用可能",
    请输入支付密码:"支払いパスワードを入力してください",
    请输入提币数量:"出金額を入力してください",
    全部:"全て",
    支付密码:"支払いパスワード",
    地址:"住所",
    委托价:"注文価格",
    成交时间:"トランザクション時間",
    成交金额:"ひっくり返す",
    委托中:"委託中",
    持仓中:"位置している",
    平仓中:"ポジションクローズ",
    已平仓:"ポジションをクローズ",
    开仓倍数:"複数開く",
    委托价格:"手数料価格",
    收盘价:"終値",
    收益率:"利益率",
    平仓时间:"閉店時間",
    请输入转换数量:"換算数量を入力してください",
    请上传付款凭证:"支払い伝票をアップロードしてください",
    开盘价:"始値",
    开市中:"開ける",
    已休市:"市場は閉鎖されました",
    美股:"米国株",
    平仓价:"終値",
    到期结算完成:"満期決済完了",
    印度股票:"インド株",
    马来股票:"マレー株",
    结算中:"沈降",
    越南股票:"ベトナム株",
    设置资金密码:"ファンドのパスワードを設定する",
    请输入资金密码:"ファンドのパスワードを入力してください",
    取消:"キャンセル",
    确定:"もちろん",
    止损价:"ストップロス価格",
    请输入止损价格:"ストップロス価格を入力してください",
    请输入止盈价格:"テイクプロフィット価格を入力してください",
    止盈价:"利食い価格",
    设置止盈止损:"テイクプロフィットとストップロスを設定する",
    请输入关键词:"キーワードを入力してください",
    搜索结果:"の検索結果",
    添加收款方式:"支払い方法を追加する",
    高级认证:"高度な認定",
    历史委托:"歴史委員会",
    选择区域码:"市外局番を選択してください",
    请上传身份证图片:"身分証明書の写真をアップロードしてください",
    请上传护照照片:"パスポートの写真をアップロードしてください",
    请输入提币地址:"出金アドレスを入力してください",
    设置语言:"言語設定",
    最低金额: "最小額",
    购买金额: "購入価格",
    请输入要搜索的国家名称: "検索したい国の名前を入力してください",
    确定执行该操作: "これを行うことを確認します?",
    历史搜索: "履歴検索",
    现货持仓: "スポット位置",
    永续持仓: "永久的な地位",
    到期结算中: "満期時の決済",
    火花图: "スパークダイアグラム",
    计价单位: "販売単位",
    您拒绝了链接: "リンクを拒否しました",
    连接钱包成功: "ウォレット接続に成功しました",
    已断开钱包: "ウォレットが切断されました",
    钱包切换成功: "ウォレットの切り替えが成功しました",
    请先安装钱包插件: "まずウォレットプラグインをインストールしてください",
    连接钱包: "ウォレットを接続する",
    交易: "貿易",
    确认报价: "見積書の確認",
    您将获得: "あなたは得るでしょう",
    兑换自: "から引き換える",
    汇率: "為替レート",
    返回: "戻る",
    兑换: "交換",
    消息: "情報",
    身份证反面照片: "IDカードの裏面の写真",
    身份证正面照片: "IDカードの表面写真",
    手持身份证照片: "IDカードを持った写真",
    划转: "移行",
    请输入划转数量: "送金額を入力してください(USD)",
    邀请链接: "招待リンク",
    资料总览: "データの概要",
    推广规则: "プロモーションルール",
    总邀请人数: "招待者の総数",
    总佣金: "合計手数料",
    安全绑定: "安全なバインディング",
    规则1: "1.このアドレスは {type} のみを受け入れます。{type} 以外のアセットをこのアドレスに転送しないでください。転送しないと、アセットが取得されません。",
    规则2: "2.上記のアドレスにリチャージした後、ネットワーク ノードの確認を待つ必要があります。ネットワーク ノードが確認すると、資産は自動的にアカウントに到着します。到着状況は Web サイトのお知らせの形でお知らせします。",
    规则3: "3.リチャージアドレスは頻繁には変更されず、繰り返しリチャージできます。変更があった場合はウェブサイトのお知らせでお知らせします。",

    安全中心: "セキュリティセンター",
    绑定手机号: "携帯電話番号をバインドする",
    认证中心: "認証センター",
    身份认证: "認証",
    认证要求: "認定要件",
    政府发行的证件: "政府発行の書類",
    功能与限制: "機能と制限事項",
    无限额: "制限なし",
    预计审核时间: "推定レビュー時間: 60 分",
    开始认证: "認定を開始する",
    充币规则: "入金ルール",
    套期保值: "ヘッジ、リスクヘッジ",
    登陆后继续: "続行するにはログインしてください",
    请选择充值方式: "チャージ方法を選択してください",
    请选择取款方式: "出金方法を選択してください",
    客服充值: "カスタマーサービスチャージ",
    数字货币: "デジタル通貨",
    银行取款: "銀行出金",
    请输入金额: "金額を入力してください",
    银行名称: "銀行名",
    银行卡号: "銀行カード番号",
    请输入: "入力してください",
    请选择: "選択してください",
    类型: "タイプ",
    可用金额: "利用可能金額",
    提款: "出金"
}


// WEBPACK FOOTER //
// ./src/lang/jp.js